﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basics/tk.manager';
import TKViewport from '@tk/basics/tk.viewport';
import TKFormDatepicker from '@tk/controls/tk.form.datepicker';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@tk/controls/tk.form.validator';
import TKDialog from '@tk/components/tk.dialog';
import TKTable from '@tk/components/tk.table';
import TKTooltip from '@tk/components/tk.tooltip';
import TKBasketButton from '@tk/components/tk.basket.button';
import TKQuickOrder from '@tk/components/tk.quick.order';
import TKStock from '@tk/components/tk.stock';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKClipboard from '@tk/components/tk.clipboard';
import TKStatusConsole from '@tk/components/tk.status.console';
import TKRequestManager from '@tk/basics/tk.request.manager';
import TKTracker from '@tk/components/tracker/tk.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';
import TKStaticContent from '@tk/controls/tk.static.content';

import 'tippy.js/dist/tippy.css';
import 'flatpickr/dist/flatpickr.min.css';
import '@scss/modules/basket.scss';

export default class Basket extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-request-manager', constructor: TKRequestManager },
            { name: 'tk-viewport', constructor: TKViewport },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-status-console', constructor: TKStatusConsole },
            { name: 'tk-clipboard', constructor: TKClipboard },
            { name: 'tk-form-datepicker', constructor: TKFormDatepicker },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'tk-table', constructor: TKTable },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-basket-button', constructor: TKBasketButton },
            { name: 'tk-quick-order', constructor: TKQuickOrder },
            { name: 'tk-stock', constructor: TKStock },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-tracking', constructor: TKTracking },
            { name: 'tk-static-content', constructor: TKStaticContent },
        ]);
    }
}

new Basket();
